import type { ImageItem } from './impls/image-selector-dialog-service';

/**
 * 图片保存选项
 */
export interface SaveImagesOptions {
    /** 任务ID */
    taskId?: string;
    /** 要保存的图片列表 */
    images: ImageItem[];
}

/**
 * 图片保存结果
 */
export type SaveImagesResult = ImageItem[];

/**
 * 图片保存服务接口
 * 负责将选中的图片保存到服务器
 */
export interface ImageSaveService {
    /**
     * 保存选中的图片到服务器
     * @param options 保存选项
     * @returns 保存结果
     */
    saveSelectedImages(options: SaveImagesOptions): Promise<SaveImagesResult>;
}

export const ImageSaveService = Symbol.for('ImageSaveService');
